import { createContext, useContext, useEffect, useState } from "react";
import { connectivity } from "@/services/connectivity";

const ConnectivityContext = createContext({ online: true, checking: false, lastSuccess: null });

export function ConnectivityProvider({ children }) {
  const [state, setState] = useState({ ...connectivity.state });

  useEffect(() => {
    connectivity.start();
    const unsub = connectivity.subscribe(setState);
    return () => { unsub(); connectivity.stop(); };
  }, []);

  return (
    <ConnectivityContext.Provider value={state}>
      {children}
    </ConnectivityContext.Provider>
  );
}

export function useConnectivity() {
  return useContext(ConnectivityContext);
}
